import { IBaseGameSettingsModel, IBaseMessageResponse, IBaseServerResponse, IBaseSettingsResponse } from '@game-studio/arcade-base';

export interface IGoldenPrize {
    InTicket: boolean;
    Bird: number;
}
interface IDONDGameMessage extends IBaseMessageResponse {
    Symbols: number[];
    GoldenBird: IGoldenPrize;
    Payout: number;
}

interface IDONDGameSettings extends IBaseSettingsResponse {
    WinMultipliers: number[];
}
export interface IDONDServerResponse extends IBaseServerResponse {
    GameSettings: IDONDGameSettings;
    GameMessage: IDONDGameMessage;
}
export class GameSettings implements IBaseGameSettingsModel {
    public static get Instance(): GameSettings {
        return this._instance || (this._instance = new GameSettings());
    }
    private static _instance: GameSettings;

    public engineVersion: string = '';
    public rtp: string = '';
    public maxWinStakeMultiplier: number;
    public winMultipliers: number[] = [];
    public stakeOptions: number[];
    public defaultStake: number;

    public setData(responseData: IDONDServerResponse): void {
        this.winMultipliers = responseData.GameSettings.WinMultipliers;
        this.maxWinStakeMultiplier = Math.max(...responseData.GameSettings.WinMultipliers)
        this.engineVersion = responseData.GameSettings.Version;
        this.defaultStake = responseData.GameSettings.DefaultStake;
        this.stakeOptions = responseData.GameSettings.StakeOptions;

        if (responseData.GameSettings.RTP) {
            this.rtp = responseData.GameSettings.RTP;
        } else if (responseData.GameSettings.Rtp) {
            this.rtp = responseData.GameSettings.Rtp
        } else {
            throw new Error('Missing RTP value from engine response');
        }
    }
}

export const gameSettings = GameSettings.Instance;
